import { boards } from "../../../mocks/homeData";

export default function Boards() {
  const lead = boards[0];
  const rest = boards.slice(1);
  return (
    <section id="boards" className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between">
        <div>
          <span className="text-xs font-bold tracking-widest text-primary-600">FIELD BOARDS</span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            分区现场 · 图文并重
          </h2>
        </div>
        <p className="hidden text-sm text-foreground-500 sm:block">每个分区，都是一张摊开待补的讨论桌</p>
      </div>

      {/* 大分区卡：宽幅图文 */}
      <article className="group mt-8 grid grid-cols-1 overflow-hidden rounded-2xl border border-background-200 bg-background-50 lg:grid-cols-2">
        <div className="relative overflow-hidden">
          <img
            src={lead.img}
            alt={lead.title}
            className="h-60 w-full object-cover transition-transform duration-500 group-hover:scale-105 md:h-full"
          />
          <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
            <i className="ri-archive-fill"></i> {lead.tag}
          </span>
        </div>
        <div className="flex flex-col justify-center p-6 md:p-8">
          <h3 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">{lead.title}</h3>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{lead.desc}</p>
          <div className="mt-5 flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-bar-chart-line"></i> {lead.stat}
            </span>
            <a
              href="#talk"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-accent-700 hover:text-accent-800 cursor-pointer"
            >
              进分区看看 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </article>

      {/* 三个小分区卡 */}
      <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {rest.map((b) => (
          <article key={b.title} className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50">
            <div className="relative overflow-hidden">
              <img
                src={b.img}
                alt={b.title}
                className="h-44 w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-semibold text-primary-700 backdrop-blur-sm">
                <i className="ri-price-tag-3-line"></i> {b.tag}
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-lg font-black text-foreground-950">{b.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600 line-clamp-2">{b.desc}</p>
              <p className="mt-3 text-xs font-medium text-foreground-400">{b.stat}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}